import type { TablerIcon } from '@tabler/icons-react';
import {
  IconCurrencyDollar,
  IconCurrencyEuro,
  IconCurrencyPound,
} from '@tabler/icons-react';

export type SlaCurrencyCode = 'EUR' | 'USD' | 'GBP';

export type SlaCurrencyConfig = {
  icon: TablerIcon;
  color: string;
};

export const SLA_CURRENCY_CODES: SlaCurrencyCode[] = ['EUR', 'USD', 'GBP'];

export const SLA_CURRENCY_CONFIG: Record<SlaCurrencyCode, SlaCurrencyConfig> = {
  EUR: { icon: IconCurrencyEuro, color: '#1e6df6' },
  USD: { icon: IconCurrencyDollar, color: '#00a87e' },
  GBP: { icon: IconCurrencyPound, color: '#7c3aed' },
};

export function getSlaCurrencyConfig(
  code: string,
): SlaCurrencyConfig | undefined {
  return SLA_CURRENCY_CONFIG[code as SlaCurrencyCode];
}
